<template>
<v-menu offset-y>
    <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" class="pr-3">
            <v-badge color="accent" overlap>
                <template v-slot:badge>
                    <span v-if="counter > 0">{{ counter }}</span>
                </template>
                <v-icon>mdi-bell</v-icon>
            </v-badge>
        </v-btn>
    </template>
    <v-list v-if="notifications && notifications.length > 0">
        <v-list-item v-for="notification in notifications" :key="notification.id">
            <v-list-item-icon>
                <v-icon>
                    mdi-account
                </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>
                    {{ notification.titulo }}
                </v-list-item-title>
                <v-list-item-subtitle>
                    {{ notification.mensaje }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-list>
    <v-list v-else>
        <v-list-item>
            <v-list-item-icon>
                <v-icon>
                    mdi-account
                </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                No cuenta con notificaciones
            </v-list-item-content>
        </v-list-item>
    </v-list>
</v-menu>
</template>

<script>
export default {
    props: {
        token: {
            type: String,
            required: true
        }
    },
    data: () => ({
        counter: 0,
        notifications: []
    }),

    mounted() {
    
    },
    methods: {
        async getNotifications() {
            const response = await this.$socket.invoke('GetNotifications')
            this.notifications = response
            this.counter = response.length
        }
    },
    sockets: {
        Noti(data) {
            this.getNotifications()
        },
        CON() {
            this.getNotifications()
        }
    }
}
</script>
